module.exports = __webpack_public_path__ + "static/2ac3a3cde233f5ca8f0a0c229b08fa8c.svg";